import { BestWebsiteDesignCompanyBurDubai } from "../../Pages/AllSeoPages/WebDevelopment/BestWebDesignBurDubai";
import { BestWebManagementServicesDifc } from "../../Pages/AllSeoPages/WebDevelopment/BestWebManagementServicesDifc";
import { WebDevelopmentAgencyBurDubai } from "../../Pages/AllSeoPages/WebDevelopment/bur_dubai/WebDevelopmentAgencyBurDubai";
import { CustomWebsiteDevelopmentAlBarsha } from "../../Pages/AllSeoPages/WebDevelopment/CustomWebsiteDevelopmentAlBarsha";
import { DifcProfessionalWebDesigners } from "../../Pages/AllSeoPages/WebDevelopment/DifcProfessionalWebDesigners";
import { WebDevelopmentAgencyDubai } from "../../Pages/AllSeoPages/WebDevelopment/dubai/WebDevelopmentAgencyDubai";
import { ResponsiveWebsiteDesignBurDubai } from "../../Pages/AllSeoPages/WebDevelopment/ResponsiveWebDesignBurDubai";
import { WebHostingSolutionsBurDubai } from "../../Pages/AllSeoPages/WebDevelopment/WebHostingSolutionsBurDubai";
import { WebManagementServicesDifc } from "../../Pages/AllSeoPages/WebDevelopment/WebManagementServicesDifc";
import { WebsiteDesignAndDevelopmentInDIFC } from "../../Pages/AllSeoPages/WebDevelopment/WebsiteDesignAndDevelopmentInDIFC";
import { WebsiteMaintenanceAlBarsha } from "../../Pages/AllSeoPages/WebDevelopment/WebsiteMaintenanceAlBarsha";
import { Helmet } from "react-helmet";

export const WebDevelopmentAgencyDubaiPage = () => (
  <>
    <Helmet>
      <title>Web Design & Development Agency in Dubai | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset, a premier web design and development agency in Dubai, builds custom, responsive websites and e-commerce platforms for Bur Dubai, Al Barsha, DIFC, Deira, Jumeirah, Dubai Marina. Contact us!"
      />
      <meta
        name="keywords"
        content="web design agency Dubai, web development agency Dubai, custom website design Dubai, e-commerce development Dubai, web design Bur Dubai, web development Al Barsha, web design DIFC, web development Deira, web design Jumeirah, web development Dubai Marina"
      />
      <meta
        property="og:title"
        content="Web Design & Development Agency in Dubai | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="Create stunning websites with MilaajBrandset, a web design and development agency in Dubai. Serving Bur Dubai, Al Barsha, DIFC, Deira, Jumeirah, Dubai Marina. Contact us now!"
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://milaajbrandset.com/web-development"
      />
      <meta
        property="og:image"
        content="https://milaajbrandset.com/og-image.jpg"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Web Design & Development Agency in Dubai | MilaajBrandset"
      />
      <meta
        name="twitter:description"
        content="Create stunning websites with MilaajBrandset, a web design and development agency in Dubai. Serving Bur Dubai, Al Barsha, DIFC, Deira, Jumeirah, Dubai Marina. Contact us now!"
      />
      <meta
        name="twitter:image"
        content="https://milaajbrandset.com/og-image.jpg"
      />
      <script type="application/ld+json">
        {`
      {
        "@context": "https://schema.org",
        "@type": "ProfessionalService",
        "name": "MilaajBrandset",
        "url": "https://milaajbrandset.com/web-development",
        "logo": "https://milaajbrandset.com/og-image.jpg",
        "image": "https://milaajbrandset.com/og-image.jpg",
        "description": "MilaajBrandset is a web design and development agency in Dubai, offering custom websites and e-commerce solutions for businesses in Bur Dubai, Al Barsha, DIFC, Deira, Jumeirah, Dubai Marina.",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Dubai",
          "addressCountry": "AE"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+971-52-524-4884",
          "contactType": "customer service",
          "email": "support@milaajbrandset.com"
        },
        "sameAs": [
          "https://www.facebook.com/profile.php?id=61562903405669",
          "https://www.instagram.com/milaajbrandset/",
          "https://www.linkedin.com/company/milaaj-brandset/"
        ]
      }
    `}
      </script>
    </Helmet>
    <WebDevelopmentAgencyDubai />
  </>
);

export const WebDevelopmentAgencyBurDubaiPage = () => (
  <>
    <Helmet>
      <title>Web Development Agency in Bur Dubai | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset is a web development agency in Bur Dubai, offering custom web development solutions for businesses. From e-commerce platforms to corporate websites, we help you build dynamic and engaging websites in Bur Dubai."
      />
      <meta
        name="keywords"
        content="web development agency in Bur Dubai, Bur Dubai web development, custom website development, e-commerce solutions Bur Dubai"
      />
      <meta
        property="og:title"
        content="Web Development Agency in Bur Dubai | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="A web development agency in Bur Dubai offering custom web development solutions for businesses. From e-commerce platforms to corporate websites, we help you build dynamic and engaging websites in Bur Dubai."
      />
      <script type="application/ld+json">
        {`
            {
              "@context": "https://schema.org",
              "@type": "ProfessionalService",
              "name": "MilaajBrandset",
              "image": "https://milaajbrandset.com/favicon.ico",
              "description": "A web development agency in Bur Dubai offering custom web development solutions for businesses.",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Bur Dubai",
                "addressLocality": "Dubai",
                "postalCode": "XXXXX",
                "addressCountry": "AE"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 25.2631,
                "longitude": 55.2975
              }
            }
          `}
      </script>
    </Helmet>
    <WebDevelopmentAgencyBurDubai />
  </>
);

export const WebManagementServicesDifcPage = () => (
  <>
    <Helmet>
      <title>Web Management Services in DIFC | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset offers comprehensive web management services in DIFC to ensure your website runs smoothly and effectively. From regular updates to technical support, we help maintain your online presence and drive growth in DIFC."
      />
      <meta
        name="keywords"
        content="web management services in DIFC, DIFC web management, website maintenance DIFC, technical support DIFC"
      />
      <meta
        property="og:title"
        content="Web Management Services in DIFC | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset offers comprehensive web management services in DIFC to ensure your website runs smoothly and effectively. From regular updates to technical support, we help maintain your online presence and drive growth in DIFC."
      />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset offers comprehensive web management services in DIFC to ensure your website runs smoothly and effectively.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "DIFC",
              "addressLocality": "Dubai",
              "postalCode": "XXXXX",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2631,
              "longitude": 55.2975
            }
          }
        `}
      </script>
    </Helmet>
    <WebManagementServicesDifc />
  </>
);

export const WebHostingSolutionsBurDubaiPage = () => (
  <>
    <Helmet>
      <title>Web Hosting Solutions in Bur Dubai | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset offers reliable and scalable web hosting solutions in Bur Dubai to ensure your website performs optimally. From shared hosting to dedicated servers, we provide the best hosting options to meet your business needs."
      />
      <meta
        name="keywords"
        content="web hosting solutions in Bur Dubai, Bur Dubai web hosting, reliable hosting Bur Dubai, scalable hosting Bur Dubai"
      />
      <meta
        property="og:title"
        content="Web Hosting Solutions in Bur Dubai | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset offers reliable and scalable web hosting solutions in Bur Dubai to ensure your website performs optimally. From shared hosting to dedicated servers, we provide the best hosting options to meet your business needs."
      />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset offers reliable and scalable web hosting solutions in Bur Dubai to ensure your website performs optimally.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Bur Dubai",
              "addressLocality": "Dubai",
              "postalCode": "XXXXX",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2631,
              "longitude": 55.2975
            }
          }
        `}
      </script>
    </Helmet>
    <WebHostingSolutionsBurDubai />
  </>
);

export const WebsiteMaintenanceAlBarshaPage = () => (
  <>
    <Helmet>
      <title>Website Maintenance in Al Barsha | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset offers comprehensive website maintenance services in Al Barsha to ensure your website remains up-to-date and performs optimally. From regular updates to technical support, we help maintain your online presence and drive growth in Al Barsha."
      />
      <meta
        name="keywords"
        content="website maintenance in Al Barsha, Al Barsha website maintenance, reliable website maintenance, Al Barsha web management"
      />
      <meta
        property="og:title"
        content="Website Maintenance in Al Barsha | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset offers comprehensive website maintenance services in Al Barsha to ensure your website remains up-to-date and performs optimally. From regular updates to technical support, we help maintain your online presence and drive growth in Al Barsha."
      />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset offers comprehensive website maintenance services in Al Barsha to ensure your website remains up-to-date and performs optimally.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Al Barsha",
              "addressLocality": "Dubai",
              "postalCode": "XXXXX",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2631,
              "longitude": 55.2975
            }
          }
        `}
      </script>
    </Helmet>
    <WebsiteMaintenanceAlBarsha />
  </>
);

export const BestWebManagementServicesDifcPage = () => (
  <>
    <Helmet>
      <title>Best Web Management Services in DIFC | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset provides the best web management services in DIFC to ensure your website runs smoothly and effectively. From regular updates to advanced security, we handle everything to help your business grow in DIFC."
      />
      <meta
        name="keywords"
        content="best web management services in DIFC, DIFC web management, reliable web management, DIFC website maintenance"
      />
      <meta
        property="og:title"
        content="Best Web Management Services in DIFC | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset provides the best web management services in DIFC to ensure your website runs smoothly and effectively. From regular updates to advanced security, we handle everything to help your business grow in DIFC."
      />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset provides the best web management services in DIFC to ensure your website runs smoothly and effectively.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "DIFC",
              "addressLocality": "Dubai",
              "postalCode": "XXXXX",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2631,
              "longitude": 55.2975
            }
          }
        `}
      </script>
    </Helmet>
    <BestWebManagementServicesDifc />
  </>
);

export const CustomWebsiteDevelopmentAlBarshaPage = () => (
  <>
    <Helmet>
      <title>Custom Website Development in Al Barsha | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset offers custom website development services in Al Barsha to create unique and tailored digital experiences for your business. From e-commerce platforms to corporate websites, we ensure your online presence stands out and drives growth in Al Barsha."
      />
      <meta
        name="keywords"
        content="custom website development in Al Barsha, Al Barsha web development, tailored website solutions, Al Barsha digital marketing"
      />
      <meta
        property="og:title"
        content="Custom Website Development in Al Barsha | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset offers custom website development services in Al Barsha to create unique and tailored digital experiences for your business. From e-commerce platforms to corporate websites, we ensure your online presence stands out and drives growth in Al Barsha."
      />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset offers custom website development services in Al Barsha to create unique and tailored digital experiences for your business.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Al Barsha",
              "addressLocality": "Dubai",
              "postalCode": "XXXXX",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2631,
              "longitude": 55.2975
            }
          }
        `}
      </script>
    </Helmet>
    <CustomWebsiteDevelopmentAlBarsha />
  </>
);

export const DifcProfessionalWebDesignersPage = () => (
  <>
    <Helmet>
      <title>DIFC Professional Web Designers | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset offers professional web design services in DIFC to create stunning and functional websites tailored to your business needs. From branding to user experience, we ensure your online presence stands out in DIFC."
      />
      <meta
        name="keywords"
        content="DIFC professional web designers, web design in DIFC, custom web design DIFC, web development DIFC"
      />
      <meta
        property="og:title"
        content="DIFC Professional Web Designers | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset offers professional web design services in DIFC to create stunning and functional websites tailored to your business needs. From branding to user experience, we ensure your online presence stands out in DIFC."
      />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset offers professional web design services in DIFC to create stunning and functional websites tailored to your business needs.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "DIFC",
              "addressLocality": "Dubai",
              "postalCode": "XXXXX",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2631,
              "longitude": 55.2975
            }
          }
        `}
      </script>
    </Helmet>
    <DifcProfessionalWebDesigners />
  </>
);

export const ResponsiveWebsiteDesignBurDubaiPage = () => (
  <>
    <Helmet>
      <title>Responsive Website Design in Bur Dubai | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset offers professional responsive website design services in Bur Dubai. Our team creates mobile-friendly websites that engage users and drive conversions, helping startups and businesses succeed online."
      />
      <meta
        name="keywords"
        content="responsive website design Bur Dubai, mobile-friendly websites Bur Dubai, web design Bur Dubai, startup web design"
      />
      <meta
        property="og:title"
        content="Responsive Website Design in Bur Dubai | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset offers professional responsive website design services in Bur Dubai. Our team creates mobile-friendly websites that engage users and drive conversions, helping startups and businesses succeed online."
      />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset offers professional responsive website design services in Bur Dubai. Our team creates mobile-friendly websites that engage users and drive conversions.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Bur Dubai",
              "addressLocality": "Dubai",
              "postalCode": "XXXXX",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2652,
              "longitude": 55.3095
            }
          }
        `}
      </script>
    </Helmet>
    <ResponsiveWebsiteDesignBurDubai />
  </>
);

export const BestWebsiteDesignCompanyBurDubaiPage = () => (
  <>
    <Helmet>
      <title>Best Website Design Company in Bur Dubai | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset is the best website design company in Bur Dubai. Our team delivers innovative, high-performing websites tailored to your business needs, helping startups and businesses succeed online."
      />
      <meta
        name="keywords"
        content="best website design company Bur Dubai, web design Bur Dubai, website development Bur Dubai, startup web design"
      />
      <meta
        property="og:title"
        content="Best Website Design Company in Bur Dubai | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset is the best website design company in Bur Dubai. Our team delivers innovative, high-performing websites tailored to your business needs, helping startups and businesses succeed online."
      />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset is the best website design company in Bur Dubai, offering innovative and high-performing websites tailored to your business needs.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Bur Dubai",
              "addressLocality": "Dubai",
              "postalCode": "XXXXX",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2652,
              "longitude": 55.3095
            }
          }
        `}
      </script>
    </Helmet>
    <BestWebsiteDesignCompanyBurDubai />
  </>
);

export const WebsiteDesignAndDevelopmentSEO = () => (
  <>
    <Helmet>
      <title>Website Design and Development in DIFC | MilaajBrandset</title>
      <meta
        name="description"
        content="MilaajBrandset offers professional website design and development services in DIFC. Create stunning, high-performance websites tailored to your business needs."
      />
      <meta
        name="keywords"
        content="website design DIFC, web development DIFC, responsive website DIFC, e-commerce website DIFC"
      />
      <meta
        property="og:title"
        content="Website Design and Development in DIFC | MilaajBrandset"
      />
      <meta
        property="og:description"
        content="MilaajBrandset offers professional website design and development services in DIFC. Create stunning, high-performance websites tailored to your business needs."
      />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "MilaajBrandset",
            "image": "https://milaajbrandset.com/favicon.ico",
            "description": "MilaajBrandset provides professional website design and development services in DIFC, helping businesses create high-performance websites.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "DIFC",
              "addressLocality": "Dubai",
              "postalCode": "XXXXX",
              "addressCountry": "AE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 25.2631,
              "longitude": 55.2975
            }
          }
        `}
      </script>
    </Helmet>
    <WebsiteDesignAndDevelopmentInDIFC />
  </>
);
